import { useCallback, useEffect, useState } from 'react';

// Выбор отображения заработка (CR-F18-019): 'net' — с учётом расчётной комиссии хеджа (по умолчанию: решение владельца 2026-11-02 по OQ-F18v2-44,
// «комиссию учитывать, но чтобы можно было посмотреть и без неё»), 'gross' — без комиссии хеджа. Один выбор на все экраны заработка: хранится в браузере (удобство просмотра, не состояние системы) и рассылается событием,
// поэтому таблица, график и блок системы переключаются одновременно. Хранилище может быть недоступно (приватное окно, запрет) —
// тогда выбор живёт в памяти страницы и всё равно работает.
export const FEE_MODES = ['gross', 'net'];
const LS_KEY = 'pnl.fee.mode';
const EVENT = 'pnl-fee-mode-change';
export const DEFAULT_FEE_MODE = 'net';
let memMode = DEFAULT_FEE_MODE;

export function readFeeMode() {
  try {
    const v = window.localStorage.getItem(LS_KEY);
    if (FEE_MODES.includes(v)) { memMode = v; return v; }
  } catch (e) { /* нет хранилища */ }
  return memMode;
}

export function writeFeeMode(mode) {
  if (!FEE_MODES.includes(mode)) return;
  memMode = mode;
  try { window.localStorage.setItem(LS_KEY, mode); } catch (e) { /* не критично */ }
  try { window.dispatchEvent(new Event(EVENT)); } catch (e) { /* нет window — ничего слушать */ }
}

export default function useHedgeFeeMode() {
  const [mode, setMode] = useState(readFeeMode);
  useEffect(() => {
    const sync = () => setMode(readFeeMode());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);   // другая вкладка того же браузера
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener('storage', sync); };
  }, []);
  const set = useCallback((m) => writeFeeMode(m), []);
  return [mode, set];
}
